module.exports = __webpack_public_path__ + "static/media/jetson_one_render_14.443f224f.jpg";